import type { IUseGetOptions } from "@app/common/types";
import { useContext } from "react";
import { useMutation, useQuery } from "react-query";

import { QueryKeys } from "./constants/QueryKeys";
import { CheckoutSessionContext, ICheckoutSessionContext } from "./context/CheckoutSessionContext";
import {
    getCheckoutBookingValidatableDependencyData,
    getPCIBookingAccessToken,
    IGetCheckoutBookingValidatableDependencyDataResult,
    upsertCheckoutSession,
} from "./queries";
import { ICheckoutSessionState, IPCIBookingAccessToken } from "./types";

export const useCheckoutSessionContext = () => {
    const context = useContext<ICheckoutSessionContext>(CheckoutSessionContext);

    if (context === undefined) {
        throw new Error("useCheckoutSessionContext must be used within a CheckoutSessionContextProvider");
    }

    return context;
};

export const useUpsertCheckoutSession = (propertyId: string, searchQuery: string) =>
    useMutation((state?: ICheckoutSessionState) => upsertCheckoutSession(propertyId, searchQuery, state));

export const useGetPCIBookingAccessToken = (options?: IUseGetOptions) =>
    useQuery<IPCIBookingAccessToken, Error>(QueryKeys.PCIBookingAccessToken, () => getPCIBookingAccessToken(), options);

export const useGetCheckoutBookingValidatableDependencyData = (propertyId: string, bookingId: string, options?: IUseGetOptions) =>
    useQuery<IGetCheckoutBookingValidatableDependencyDataResult, Error>(
        [QueryKeys.CheckoutBookingValidatableDependencyData, propertyId, bookingId],
        () => getCheckoutBookingValidatableDependencyData({ propertyId, bookingId }),
        options
    );
